jQuery(document).ready(function() {
		jQuery('#sca-fg-today-offer-widget').attr("title","Offer widget");
	jQuery('a[href="https://www.facebook.com/ArtizanCoffee/"]').attr('aria-label', "Follow on Facebook, opens in new tab");	
	jQuery('a[href="https://x.com/ArtizanCoffee"]').attr('aria-label', "Follow on Twitter, opens in new tab");	
	jQuery('a[href="https://www.instagram.com/artizancoffeecompany/"]').attr('aria-label', "Follow on instagram, opens in new tab");	
	jQuery('a[href="https://www.pinterest.com/artizancoffee/"]').attr('aria-label', "Follow on pinterest, opens in new tab");	
	jQuery('a[href="https://www.tiktok.com/@artizancoffee"]').attr('aria-label', "Follow on tiktok, opens in new tab");	

	jQuery('#shopify-section-template--25036994085137__impact_text_NXYeCn a').attr("aria-label","Lear About Our Impact Here, opens external website");
	
  jQuery('.footer-links__column.footer-links__column--wide p:eq(0)').attr("aria-level","2");
  jQuery('.product-zoom-button').attr("aria-level","2");
  jQuery('br').attr("aria-hidden","true");

  jQuery('#shopify-section-template--25036995297553__rich_text_apHYhL p:eq(0) ').attr("role","heading");
  jQuery('#shopify-section-template--25036995297553__rich_text_apHYhL p:eq(0) ').attr("aria-level","2");
  jQuery('.multi-column.scroll-area.bleed .h1').attr("role","heading");
  jQuery('.multi-column.scroll-area.bleed .h1').attr("aria-level","2");
  jQuery('.section.section-blends.section-full.text-custom iframe').attr("title","View on Google Maps, opens in a new tab");


  
  

});


$(document)

  // Toggle submenu on click
  .on('click', '.submenu-toggle', function(e) {
    e.preventDefault();
    e.stopPropagation(); // prevent <summary> link click

    const $toggle = $(this);
    const $details = $toggle.closest('details[is="mega-menu-disclosure"], details[is="dropdown-disclosure"]');
    const isOpen = $details.attr('open') !== undefined;

    if (isOpen) {
      $details.removeAttr('open');
      $toggle.attr('aria-expanded', 'false');
    } else {
      // Close other open menus of the same type
      const isMega = $details.is('[is="mega-menu-disclosure"]');
      const selector = isMega
        ? 'details[is="mega-menu-disclosure"][open]'
        : 'details[is="dropdown-disclosure"][open]';

      $(selector)
        .not($details)
        .removeAttr('open')
        .find('.submenu-toggle')
        .attr('aria-expanded', 'false');

      $details.attr('open', '');
      $toggle.attr('aria-expanded', 'true');
    }
  })

  // Close submenu when pressing ESC while focus is inside a menu
  .on('keydown', function(e) {
    if (e.key === 'Escape' || e.key === 'Esc' || e.which === 27) {
      const $focused = $(document.activeElement);
      const $menu = $focused.closest('.mega-menu, .dropdown-menu');

      if ($menu.length) {
        const $details = $menu.closest('details[is="mega-menu-disclosure"], details[is="dropdown-disclosure"]');
        $details.removeAttr('open');
        $details.find('.submenu-toggle').attr('aria-expanded', 'false');

        // Optional: move focus back to summary
        $details.find('summary').focus();
      }
    }
  });
$(document).on('keydown', function(e) {
  // Check if ESC key was pressed
  if (e.key === 'Escape') {
    const $focused = $(':focus');
    
    // Check if focus is inside .js-modal-container-dialog
    if ($focused.closest('.js-modal-container-dialog').length) {
      $('.js-model-close-btn').trigger('click');
    }
  }
});
const targetNode = document.body;

const observer = new MutationObserver(function(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const $announcer = $('#reviewsio-announcer');
      if ($announcer.length) {
        $announcer.removeAttr('aria-live');
        observer.disconnect(); // stop observing once done
        break;
      }
    }
  }
});

observer.observe(targetNode, {
  childList: true,
  subtree: true
});
document.querySelector('.skip-to-content').addEventListener('click', function (e) {
  const target = document.querySelector('#Skip-content');
  if (target) {
    e.preventDefault();
    target.setAttribute('tabindex', '-1');
    target.focus();
  }
});
jQuery(document).ready(function ($) {
  $(document).on('keydown', '.pause-play-toggle', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });
});

/* ADA fix: give Shopify Chat toggle an accessible name safely */
(function () {
  // Only run on the homepage; remove this guard if you want sitewide.
  if (location.pathname !== '/' && location.pathname !== '/index.html') return;

  var LABEL_OPEN  = 'Open chat';
  var LABEL_CLOSE = 'Close chat';
  var WIRED_FLAG  = '__ariaWired';

  function setLabel(btn) {
    try {
      var expanded = String(btn.getAttribute('aria-expanded')) === 'true';
      var label = expanded ? LABEL_CLOSE : LABEL_OPEN;

      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);

      var sr = btn.querySelector('.sr-only');
      if (!sr) {
        sr = document.createElement('span');
        sr.className = 'sr-only';
        sr.style.cssText = 'position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;border:0!important;';
        btn.prepend(sr);
      }
      sr.textContent = label;
    } catch (_) { /* swallow all errors */ }
  }

  function wireButton(btn) {
    if (!btn || btn[WIRED_FLAG]) return false;
    btn[WIRED_FLAG] = true;
    setLabel(btn);

    // Observe just this button for aria-expanded flips
    if ('MutationObserver' in window) {
      try {
        var obs = new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            if (muts[i].attributeName === 'aria-expanded') setLabel(btn);
          }
        });
        obs.observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });

        // Clean up when leaving page
        var cleanup = function () { try { obs.disconnect(); } catch(_){} };
        window.addEventListener('pagehide', cleanup, { once: true });
        window.addEventListener('beforeunload', cleanup, { once: true });
      } catch (_) {}
    }
    return true;
  }

  function getChatButton() {
    try {
      // Shopify Inbox custom element host
      var host = document.querySelector('inbox-online-store-chat#ShopifyChat');
      if (!host) return null;
      var shadow = host.shadowRoot;      // null until ready
      if (!shadow) return null;
      return shadow.querySelector('button[data-spec="toggle-button"]');
    } catch (_) { return null; }
  }

  function tryAttachOnce() {
    var btn = getChatButton();
    if (!btn) return false;
    return wireButton(btn);
  }

  function start() {
    // 1) Try immediately
    var wired = tryAttachOnce();

    // 2) Tiny, scoped observer to notice chat widget insertion; auto-disconnects
    var bodyObs = null;
    if (!wired && 'MutationObserver' in window) {
      try {
        bodyObs = new MutationObserver(function () {
          if (tryAttachOnce()) {
            try { bodyObs.disconnect(); } catch(_) {}
            bodyObs = null;
          }
        });
        bodyObs.observe(document.body || document.documentElement, { childList: true, subtree: true });

        // Safety: stop observing after 20s regardless
        setTimeout(function () {
          if (bodyObs) { try { bodyObs.disconnect(); } catch(_) {} bodyObs = null; }
        }, 20000);
      } catch (_) {}
    }

    // 3) Capped polling as belt & suspenders (10s max)
    if (!wired) {
      var tries = 0, max = 20;
      var iv = setInterval(function () {
        tries++;
        if (tryAttachOnce() || tries >= max) {
          clearInterval(iv);
          if (bodyObs) { try { bodyObs.disconnect(); } catch(_) {} bodyObs = null; }
        }
      }, 500);
    }
  }

// Run when safe; also export a manual hook for console testing
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, { once: true });
} else {
  // Use requestIdleCallback if available to be extra polite
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(start);
  } else if (typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(function(){ start(); });
  } else {
    setTimeout(start, 0);
  }
}

// Optional: expose a debug hook
window.ArtizanADA = window.ArtizanADA || {};
window.ArtizanADA.initChatToggleA11y = start;

})();

